import React from 'react';
import "devextreme/ui/lookup";
import 'devextreme-react/date-range-box';
import { Stepper, Item as StepperItem } from 'devextreme-react/stepper';
import { MultiView } from 'devextreme-react/multi-view';
import validationEngine from 'devextreme/ui/validation_engine';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { FormattedMessage, injectIntl } from "react-intl";
import moment from 'moment';
import * as actionMailSubscriptionCrud from "../../../crud/actionMailSubscription.crud";
import { withSnackbar } from 'notistack';
import { Form, SimpleItem, RangeRule, RequiredRule, GroupItem } from 'devextreme-react/form';
import { LoadPanel } from 'devextreme-react/load-panel';
import ActionsEmailSubscriptionState from "./ActionsEmailSubscriptionState";
import { confirm } from 'devextreme/ui/dialog';
import { getCalendarSubscriptionCoverageOptions, getWeekdayOptions, getActionEmailSubscriptionReminderTypesOptions } from '../../../shared/lookup';



const validationGroups = ['dates', 'coverage', 'reminder'];



const initialState = {
    steps: [],
    selectedIndex: 0,
    updatingSubscription: false,
    nextButtonText: 'Next',
    formData: {
        actionmailsubscriptionid: 0,
        coverage: null,
        weekday_MONDAY: false,
        weekday_TUESDAY: false,
        weekday_WEDNESDAY: false,
        weekday_THURSDAY: false,
        weekday_FRIDAY: false,
        weekday_SATURDAY: false,
        weekday_SUNDAY: false,
        remindertype: null,
    },

}
class ActionsEmailSubscriptionWizard extends React.Component {

    constructor(props) {
        super(props);
        this.loadPanelRef = React.createRef();
        this.coveragerOptions = getCalendarSubscriptionCoverageOptions(this.props.intl);
        this.coveragerOptionsObj = this.coveragerOptions.reduce((obj, item) => ({ ...obj, [item.value]: item.display }), {});


        this.weekdayOptions = getWeekdayOptions(this.props.intl);
        this.weekdayOptionsObj = this.weekdayOptions.reduce((obj, item) => ({ ...obj, [item.value]: item.display }), {});

        this.reminderTypesOptions = getActionEmailSubscriptionReminderTypesOptions(this.props.intl);
        this.reminderTypesOptionsObj = this.reminderTypesOptions.reduce((obj, item) => ({ ...obj, [item.value]: item.display }), {});

        this.state = this.getInitialState();

    }
    getInitialState = () => {
        const newState = JSON.parse(JSON.stringify(initialState));
        newState.nextButtonText = this.props.intl.formatMessage({ id: 'GENERAL.BUTTON.NEXT' })
        newState.steps = [
            {
                label: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.DATES' }),
                hint: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.DATES' }),
                icon: 'daterangepicker',
            },
            {
                label: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.COVERAGE' }),
                hint: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.COVERAGE' }),
                icon: 'group',
            },
            {
                label: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.REMINDERS' }),
                hint: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.REMINDERS' }),
                icon: 'bell',
                // optional: true,
            },
            {
                label: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.CONFIRMATION' }),
                hint: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.CONFIRMATION' }),
                icon: 'checkmarkcircle',
            },
        ];
        return newState;
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
    fetchActiveSubscription = async () => {
        try {
            if (this.loadPanelRef.current) {
                this.loadPanelRef.current.instance().show();
            }

            const { data: result, config } = await actionMailSubscriptionCrud.getActiveSubscription();
            let timerMS = 100;
            if (config && config.meta && config.meta.requestStartedAt) {
                let executionTimeMs = (new Date().getTime() - config.meta.requestStartedAt);
                if (executionTimeMs < 800) {
                    timerMS = 900 - executionTimeMs;
                }
            }

            if (result) {
                this.timer = setTimeout(() => {
                    this.setState({
                        selectedIndex: 3,
                        formData: {
                            actionmailsubscriptionid: result.actionmailsubscriptionid,
                            coverage: result.coverage,
                            remindertype: result.remindertype,
                            weekday_MONDAY: result.weekday_MONDAY,
                            weekday_TUESDAY: result.weekday_TUESDAY,
                            weekday_WEDNESDAY: result.weekday_WEDNESDAY,
                            weekday_THURSDAY: result.weekday_THURSDAY,
                            weekday_FRIDAY: result.weekday_FRIDAY,
                            weekday_SATURDAY: result.weekday_SATURDAY,
                            weekday_SUNDAY: result.weekday_SUNDAY,
                        }
                    })
                    if (this.loadPanelRef.current) {
                        this.loadPanelRef.current.instance().hide();
                    }
                }, timerMS);
            }
            else {
                this.timer = setTimeout(() => {
                    if (this.loadPanelRef.current) {
                        this.loadPanelRef.current.instance().hide();
                    }
                }, timerMS);
            }
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            if (this.loadPanelRef.current) {
                this.loadPanelRef.current.instance().hide();
            }
            if (this.timer) {
                clearTimeout(this.timer);
            }
        }


    }
    onSelectionChanged = ({ component }) => {
        this.setState({ selectedIndex: (component.option('selectedIndex') ?? 0) });
    }
    onSelectionChanging = (args) => {
        if (!this.state.subscriptionURL) {
            const { component, addedItems, removedItems } = args;
            const { items = [] } = component.option();
            const addedIndex = items.findIndex((item) => item === addedItems[0]);
            const removedIndex = items.findIndex((item) => item === removedItems[0]);
            const isMoveForward = addedIndex > removedIndex;
            if (isMoveForward) {
                const isValid = this.getValidationResult(removedIndex);
                this.setStepValidationResult(removedIndex, isValid);
                if (isValid === false) {
                    args.cancel = true;
                }
            }
        }


    }
    getValidationResult = (index) => {
        if (index >= validationGroups.length) {
            return true;
        }
        return validationEngine.validateGroup(validationGroups[index]).isValid;
    }
    setStepValidationResult = (index, isValid) => {
        const newSteps = [...this.state.steps];
        newSteps[index] = { ...newSteps[index], isValid };
        this.setState({ steps: newSteps });
    }
    getInitialButtonText = (index) => {
        if (index === this.state.steps.length - 1) {
            if (this.state.formData.actionmailsubscriptionid) {
                return this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.BUTTON.CHANGE' });
            }
            else {
                return this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.BUTTON.GENERTE' });
            }

        }
        return this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.BUTTON.NEXT' });
    }
    onPrevButtonClick = () => {
        const { selectedIndex } = this.state;
        const nextIndex = selectedIndex - 1;
        const nextButtonText = this.getInitialButtonText(nextIndex);
        this.setState({ selectedIndex: nextIndex, nextButtonText });
    }
    onChangeSettingsClick = () => {

        if (this.state.formData.actionmailsubscriptionid) {
            const newState = this.getInitialState();
            newState.updatingSubscription = true;
            newState.formData.actionmailsubscriptionid = this.state.formData.actionmailsubscriptionid;
            this.setState(newState);
        }

    }
    onNextButtonClick = async () => {

        const { selectedIndex, steps, formData } = this.state;
        const currentValidationGroup = validationGroups[selectedIndex];
        const result = validationEngine.validateGroup(currentValidationGroup);

        if (result.isValid) {
            if (selectedIndex === steps.length - 1) {
                if (formData.actionmailsubscriptionid) {
                    this.updateSubscriptionURL();
                }
                else {
                    this.generateSubscription();
                }

            }
            else {
                const nextIndex = selectedIndex + 1;
                const nextButtonText = this.getInitialButtonText(nextIndex);
                // Move to Next Step
                this.setState({ selectedIndex: nextIndex, nextButtonText });
            }
        }


    }
    generateSubscription = async () => {
        try {
            this.loadPanelRef.current.instance().show();
            const { formData } = this.state;
            const payload = { ...formData };
            const { data: newSubscription } = await actionMailSubscriptionCrud.createSubscription(payload);
            const newFormData = { ...formData };
            newFormData.actionmailsubscriptionid = newSubscription.actionmailsubscriptionid;
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.MESSAGE.CREATED' }), { variant: 'success' });
            this.setState({ formData: newFormData });
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
        finally {
            this.timer = setTimeout(() => {
                if (this.loadPanelRef.current) {
                    this.loadPanelRef.current.instance().hide();
                }
            }, 500);
        }


    }
    updateSubscriptionURL = async () => {
        try {
            this.loadPanelRef.current.instance().show();
            const { formData } = this.state;
            const payload = {
                actionmailsubscriptionid: formData.actionmailsubscriptionid,
                coverage: formData.coverage,
                remindertype: formData.remindertype,
                weekday_MONDAY: formData.weekday_MONDAY,
                weekday_TUESDAY: formData.weekday_TUESDAY,
                weekday_WEDNESDAY: formData.weekday_WEDNESDAY,
                weekday_THURSDAY: formData.weekday_THURSDAY,
                weekday_FRIDAY: formData.weekday_FRIDAY,
                weekday_SATURDAY: formData.weekday_SATURDAY,
                weekday_SUNDAY: formData.weekday_SUNDAY,
            };
            await actionMailSubscriptionCrud.updateSubscription(payload);
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.MESSAGE.UPDATE' }), { variant: 'success' });
            this.setState({ updatingSubscription: false});
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
        finally {
            this.timer = setTimeout(() => {
                if (this.loadPanelRef.current) {
                    this.loadPanelRef.current.instance().hide();
                }
            }, 500);
        }

    }
    confirmCancelSubscription = async () => {
        const warningMessage = this.props.intl.formatMessage({ id: 'EMAIL_SUBSCRIPTION.CANCELLATION.MESSAGE' });
        const warningMessageTitle = this.props.intl.formatMessage({ id: 'EMAIL_SUBSCRIPTION.CANCELLATION.TITLE' });
        let result = await confirm(`<div style="max-width:50vw;">${warningMessage}</div>`, `${warningMessageTitle}`);
        return result;
    }
    onCancelSubscription = async () => {
        try {
            const isCancellationConfirmed = await this.confirmCancelSubscription();
            if (isCancellationConfirmed) {
                this.loadPanelRef.current.instance().show();
                await actionMailSubscriptionCrud.cancelSubscription();
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.MESSAGE.CANCEL' }), { variant: 'success' });
                const newState = this.getInitialState();
                this.setState(newState);
            }

        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
        finally {
            this.timer = setTimeout(() => {
                if (this.loadPanelRef.current) {
                    this.loadPanelRef.current.instance().hide();
                }
            }, 500);
        }

    }
    onClose = () => {
        if (this.props.visible) {
            const newState = this.getInitialState();
            this.setState(newState, () => {
                this.props.onDialogResult();
            });
        }
    }
    onPopupShowing = () => {

        this.fetchActiveSubscription();
    }
    render() {
        const { steps, selectedIndex, formData, nextButtonText, updatingSubscription } = this.state;
        const showStepper = !formData.actionmailsubscriptionid || updatingSubscription;
        return (
            <Popup
                visible={this.props.visible}
                onHiding={this.onClose}
                dragEnabled={true}
                hideOnOutsideClick={false}
                showTitle={true}
                title={this.props.intl.formatMessage({ id: 'EMAIL_SUBSCRIPTION.TITLE' })}
                width={800}
                minHeight={700}
                // onContentReady={this.onPopupContentReady}
                onShowing={this.onPopupShowing}
                height='auto'>
                <LoadPanel
                    ref={this.loadPanelRef}
                    // onContentReady={this.onLoadPanelContentReady}
                    shadingColor="rgba(0,0,0,0.4)"
                    // message='Fetching Calendar Subscription Info'
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    hideOnOutsideClick={false}
                    // delay={300}
                    position={{ of: '#popupContainer' }}
                />

                <>
                    <div id="ActionsCalendarSubscriptionWizard">
                        <Stepper
                            className={!showStepper ? 'readonly' : ''}
                            focusStateEnabled={showStepper}
                            selectedIndex={selectedIndex}
                            onSelectionChanged={this.onSelectionChanged}
                            onSelectionChanging={this.onSelectionChanging}
                            visible={showStepper}
                        >
                            {steps.map((step) => (
                                <StepperItem
                                    key={step.label}
                                    {...step}
                                />
                            ))}
                        </Stepper>
                        {
                            !showStepper && (<ActionsEmailSubscriptionState subscription={formData} />)
                        }
                        
                        <div className="content">
                            <MultiView
                                selectedIndex={selectedIndex}
                                focusStateEnabled={false}
                                animationEnabled={false}
                                swipeEnabled={false}
                                height={400}
                            >
                                <StepperItem >
                                    <React.Fragment>
                                        <p>
                                            <FormattedMessage id='EMAIL_SUBSCRIPTION.STEP.DATES' />
                                        </p>
                                        <Form
                                            formData={formData}
                                            validationGroup="dates"
                                            style={{ margin: 30 }}
                                        >
                                            {
                                                this.weekdayOptions.map(option => (
                                                    <SimpleItem
                                                        key={option.value}
                                                        dataField={`weekday_${option.value}`}
                                                        editorType="dxCheckBox"
                                                        label={{ visible: false }}
                                                        editorOptions={{
                                                            text: option.display,
                                                        }}
                                                    />
                                                ))
                                            }
                                        </Form>
                                    </React.Fragment>
                                </StepperItem>
                                <StepperItem>
                                    <React.Fragment>
                                        <p>
                                            <FormattedMessage id='EMAIL_SUBSCRIPTION.STEP.COVERAGE' />
                                        </p>

                                        <Form
                                            formData={formData}
                                            validationGroup="coverage"
                                            style={{ margin: 30 }}
                                        >
                                            <SimpleItem
                                                // colCount={5}
                                                isRequired={true}
                                                dataField="coverage"
                                                editorType="dxRadioGroup"
                                                editorOptions={{
                                                    layout: "horizontal",
                                                    dataSource: this.coveragerOptions,
                                                    displayExpr: 'display',
                                                    valueExpr: 'value',
                                                }}

                                                label={{ visible: false }}
                                            >
                                                {/* <RequiredRule message={"Required"} /> */}
                                            </SimpleItem>
                                        </Form>
                                    </React.Fragment>
                                </StepperItem>
                                <StepperItem >
                                    <React.Fragment>
                                        <p>
                                            <FormattedMessage id='EMAIL_SUBSCRIPTION.STEP.REMINDERS' />
                                        </p>
                                        <Form
                                            formData={formData}
                                            style={{ margin: 30 }}
                                            validationGroup="reminder"
                                        >
                                            <SimpleItem itemType="empty" />
                                            <SimpleItem
                                                isRequired={true}
                                                dataField="remindertype"
                                                editorType="dxRadioGroup"
                                                editorOptions={{
                                                    layout: "horizontal",
                                                    dataSource: this.reminderTypesOptions,
                                                    displayExpr: 'display',
                                                    valueExpr: 'value',
                                                }}

                                                label={{ visible: false }}
                                            >
                                                {/* <RequiredRule message={"Required"} /> */}
                                            </SimpleItem>
                                        </Form>
                                    </React.Fragment>
                                </StepperItem>
                                <StepperItem >
                                    <div className="summary-container">
                                        <div className="summary-item">
                                            <div className="summary-item-header"> <FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.DATES' /></div>
                                            <div className="separator"></div>
                                            {
                                                this.weekdayOptions.map(option => {
                                                    if (formData[`weekday_${option.value}`]) {
                                                        return (<span key={option.value}>{option.display}</span>);
                                                    }
                                                })

                                            }
                                        </div>

                                        <div className="summary-item">
                                            <div className="summary-item-header"><FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.COVERAGE' /></div>
                                            <div className="separator"></div>
                                            <div>
                                                {this.coveragerOptionsObj[formData.coverage]}
                                            </div>
                                        </div>


                                        <div className="summary-item">
                                            <div className="summary-item-header"><FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.REMINDERS' /></div>
                                            <div className="separator"></div>
                                            <div>
                                                {this.reminderTypesOptionsObj[formData.remindertype]}

                                            </div>

                                        </div>
                                    </div>
                                </StepperItem>
                            </MultiView>

                        </div>
                    </div>
                    <div style={{ position: "fixed", bottom: 30, left: 20 }} className="current-step">
                        {(!formData.actionmailsubscriptionid || updatingSubscription) && (
                            <React.Fragment>
                                Step <span className="selected-index">{selectedIndex + 1}</span>
                                {' of '}
                                {steps.length}
                            </React.Fragment>
                        )}
                    </div>
                </>

                <ToolbarItem
                    visible={selectedIndex !== 0 && showStepper}
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{ text: this.props.intl.formatMessage({ id: 'GENERAL.BUTTON.BACK' }), onClick: this.onPrevButtonClick }} />

                <ToolbarItem
                    visible={showStepper}
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        type: "default",
                        stylingMode: "contained",
                        text: nextButtonText,
                        // icon: '',
                        onClick: this.onNextButtonClick
                    }} />
                
                <ToolbarItem
                    visible={!showStepper && (selectedIndex === steps.length - 1)}
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        type: "danger",
                        stylingMode: "outlined",
                        text: this.props.intl.formatMessage({ id: 'EMAIL_SUBSCRIPTION.BUTTON.CANCEL_SUBSCRIPTION' }),
                        onClick: this.onCancelSubscription
                    }} />
                <ToolbarItem
                    visible={!showStepper && (selectedIndex === steps.length - 1)}
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        type: "default",
                        stylingMode: "contained",
                        text: this.props.intl.formatMessage({ id: 'EMAIL_SUBSCRIPTION.BUTTON.CHANGE_SETTINGS' }),
                        // icon: '',
                        onClick: this.onChangeSettingsClick
                    }} />

            </Popup >

        );
    }
}

export default withSnackbar(injectIntl(ActionsEmailSubscriptionWizard));